
import React from "react";
import { Classname } from "@rivtn/noseur";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { ITeamWebsite, ITournamentEditionMatch } from "../../../../../services";
import { isHomeMatch, matchParticipants, matchScores, matchWon, participantImage, participantName } from "./match";

export interface MatchRowProps {
    publicId: string;
    website: ITeamWebsite;
    match: ITournamentEditionMatch;
}

function MatchRow({ publicId, website, match: t }: MatchRowProps) {

    const labels = i18nManager.Labels.match;
    const scores = matchScores(t);
    const won = matchWon(t);
    const [first, ...others] = matchParticipants(t);
    const status = t.status === "ONGOING" ? "live" : t.status === "UPCOMING" ? "upcoming" : (won ? "win" : "loss");

    return (<a className={styles["match-row"]} target="_blank" rel="noreferrer" href={Utils.buildTournamentMatchLink(publicId, t)}>
        <span className={Classname.build(styles["match-dot"], styles[`dot-${status}`])} />
        <div className={styles["match-row-date"]}>
            <span>{Utils.fineDate(new Date(t.start_date))}</span>
            <span className={styles["match-row-comp"]}>{t.tournament_edition?.name}</span>
        </div>
        <div className={styles["match-row-teams"]}>
            {first && (<span className={styles["match-row-team"]}>
                {participantImage(first) && (<img src={participantImage(first)} alt="" />)}
                {participantName(first)}
            </span>)}
            {others.length > 0 && (<span className={styles["match-vs"]}>{labels.vs}</span>)}
            {others.map((o, i) => (<span key={o.external_id + i} className={styles["match-row-team"]}>
                {participantImage(o) && (<img src={participantImage(o)} alt="" />)}
                {participantName(o)}
            </span>))}
        </div>
        <span className={styles["match-row-hoa"]}>{isHomeMatch(website, t) ? labels.home : labels.away}</span>
        <span className={Classname.build(styles["match-row-score"], styles[`score-${status}`])}>
            {scores ? `${scores[0] ?? ""} - ${scores.slice(1).join(", ")}` : (t.status === "UPCOMING" ? labels.tbd : "-")}
        </span>
    </a>);
}

export default MatchRow;
